import { render } from "./LinktoneCard.vue?vue&type=template&id=5850b193"
import script from "./LinktoneCard.vue?vue&type=script&lang=js"
export * from "./LinktoneCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__